module.exports = __webpack_public_path__ + "static/tome_of_clear_thought-f3e74f8ce10d7a2c8c82ea5ebc4b2c4e.jpeg";